import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Settings } from './settings.model';
import { LocalStoreManager } from '../shared/services/local-store-manager.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../shared/services/local-store-manager.service";
export class SettingsService {
    constructor(http, localStorage, injector) {
        this.http = http;
        this.localStorage = localStorage;
        this.injector = injector;
        this.loadBrowserWindowEnv = () => {
            // Read environment variables from browser window
            const browserWindowEnv = window['__env'] || {};
            //const browserWindowEnv = browserWindow['__env'] || {};
            //console.log(browserWindowEnv);
            // Assign environment variables from browser window to env
            // In the current implementation, properties from env.js overwrite defaults from the EnvService.
            // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
            for (const key in browserWindowEnv) {
                if (browserWindowEnv.hasOwnProperty(key)) {
                    this._settings[key] = browserWindowEnv[key];
                }
            }
        };
        this._settings = new Settings();
    }
    loadSettings() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //https://stackoverflow.com/questions/49163532/angular-v5-service-is-getting-constructed-before-app-initializer-promise-resol
            const http = this.injector.get(HttpClient);
            // Note VT:
            // Three step process to build settings:
            //      use variables from settings.model 
            // 1.   Load file settings.json
            // 2.   get browser Window Env (window.__env) if set from Octopus in envOctopus.js
            // 3.   Load local Storage
            //      Every step override settings.model in UI
            var promise = http
                .get('settings.json') // './settings.json'
                .pipe(tap((configSettingsJson) => {
                //console.log(configSettingsJson);
                for (const key in configSettingsJson) {
                    if (configSettingsJson.hasOwnProperty(key)) {
                        this._settings[key] = configSettingsJson[key];
                    }
                }
                this.loadBrowserWindowEnv();
                //if (this._settings.useIdentityServer) {//should be before loadLocalChanges(); 
                //  this.subFleetId = 0;//It will be loaded later - after user authentification
                //}
                this.loadLocalChanges();
                //console.log(this._settings);
            }, (error) => {
                this._settings = new Settings();
                this.loadBrowserWindowEnv();
                if (this._settings.useIdentityServer) {
                    this.subFleetId = 0;
                }
                this.loadLocalChanges();
            }))
                .toPromise();
            //const zipUtil = import(`../../settings.json`)
            //  .then(function (value) {
            //    if (value) {
            //      console.log("import", value);
            //    }
            //  });
            return promise;
        });
    }
    load() {
        return new Promise(resolve => {
            this.http
                .get('./settings.json')
                .subscribe((configSettingsJson) => {
                //console.log(configSettingsJson);
                //this._settings = Object.assign({}, this._settings, configSettingsJson);
                //Object.assign(this._settings, configSettingsJson);
                for (const key in configSettingsJson) {
                    if (configSettingsJson.hasOwnProperty(key)) {
                        this._settings[key] = configSettingsJson[key];
                    }
                }
                this.loadBrowserWindowEnv();
                this.loadLocalChanges();
                //console.log(this._settings);
                resolve(this._settings);
            }, (error) => {
                this._settings = new Settings();
                this.loadBrowserWindowEnv();
                this.loadLocalChanges();
                resolve(this._settings);
            });
        });
    }
    loadLocalChanges() {
        //console.log('loadLocalChanges before', this._settings.userConfiguration.subFleetId);
        //if (this.localStorage.exists(DBkeys.SUB_FLEET_ID) && this._settings.useIdentityServer) {
        //  //this.subFleetId = this.localStorage.getDataObject<number>(DBkeys.SUB_FLEET_ID);
        //}
        //console.log('loadLocalChanges after', this._settings.userConfiguration.subFleetId);
    }
    saveToLocalStore(data, key) {
        setTimeout(() => this.localStorage.saveSessionData(data, key));
    }
    get() {
        return this._settings;
    }
    set subFleetId(value) {
        //console.log(' set subFleetId before', this._settings.userConfiguration.subFleetId);
        this._settings.userConfiguration.subFleetId = Number(value);
        //if (this._settings.useIdentityServer) {
        //  this.saveToLocalStore(Number(value), DBkeys.SUB_FLEET_ID);
        //}
        //console.log(' set subFleetId after', this._settings.userConfiguration.subFleetId);
    }
    get subFleetId() {
        //console.log(' get subFleetId before', this._settings.userConfiguration.subFleetId);
        return this._settings.userConfiguration.subFleetId;
    }
}
SettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingsService_Factory() { return new SettingsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LocalStoreManager), i0.ɵɵinject(i0.INJECTOR)); }, token: SettingsService, providedIn: "root" });
//https://juristr.com/blog/2018/01/ng-app-runtime-config/
export function settingsServiceFactory(settings) {
    // Angular will first resolve that Promise before it continues with the bootstrapping.
    return () => 
    //settings.load();
    settings.loadSettings();
}
